const apireservas = `https://apireservas.azurewebsites.net/api/`
export const GetDesgloseComision = `${apireservas}Reserva/GetDesgloseComision?bookingCode=`